import _ from "lodash";

export const PADDING_ZEROS = 3;

export const getNextItemKey = (existingItemList, keyPrefix) => {
    let lastItemKeyIndex = 0;
    let itemKeyIndexes = [];

    if (!_.isEmpty(existingItemList)) {
        const allItemKeys = _.orderBy(_.map(existingItemList, 'key'));

        _.forEach(allItemKeys, itemKey => {
            itemKeyIndexes.push(_.parseInt(_.split(itemKey, '-', 2)[1]));
        });

        itemKeyIndexes = _.orderBy(itemKeyIndexes);
        lastItemKeyIndex = itemKeyIndexes[itemKeyIndexes.length - 1];
    }

    // @ts-ignore
    return keyPrefix + '-' + _.padStart(++lastItemKeyIndex, PADDING_ZEROS, '0');
}
